import avaType from "../../../utilities/ava/avaType";
import avaBox from "../../../assets/pic/avaBox.png";
import avaShop from "../../../assets/pic/avashop.png";
import { Box } from "react-bootstrap-icons";
import "./logo.css";
import useSharedData from "../../../hooks/useSharedData";

function HeaderSection({ type = 3, mustCollected, partCount }) {
  const { isAgent } = useSharedData();

  return (
    <div className="d-flex justify-content-between">
      <h1 className="mt-5">ثبت سفارش {avaType[type].title}</h1>
      {type == 2 && (
        <div>
          <img className="logo" style={{ marginRight: 70 }} src={avaBox} />
        </div>
      )}
      {type == 1 && (
        <div style={{ marginLeft: "20rem" }}>
          <img
            style={{ width: 550, height: 250 }}
            className="logo"
            src={avaShop}
          />
        </div>
      )}
      <div>
        {type == 2 && isAgent && (
          <div className="text-start">
            <div
              className="h4 bg-uncollected-agent"
              style={{ color: "#E50000" }}
            >
              <Box size={25} style={{ color: "#482b88" }} className="m-1" /> :{" "}
              {mustCollected} سفارش شامل {partCount} بسته در انتظار جمع آوری
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HeaderSection;
